import { Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';
import React from 'react';
import { UtilsDate } from '../../../../app/orussystem/utils/UtilDate';
import ChartTemp from './chartTemp';
import { UtilsTable } from '../../../../app/orussystem/utils/UtilTable';
import { GraficasStyles } from '../GraficasStyles';

const CardTemp = ({ rows, isLoad, paperStyle, lIcms }) => {
  const classes = GraficasStyles();

  return (
    <Paper>
      <Typography className={classes.title} color='primary'>Oximetría</Typography>

      <Grid container spacing={2}>
        {/* Columna para la tabla */}
        <Grid item xs={12} lg={6}>
          <Paper className={paperStyle}>
            <Table size="small">
              <TableHead>
                <TableRow alignItems="center">
                  <TableCell align="center">Fecha</TableCell>
                  <TableCell align="center">Oximetría</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoad ? (
                  <TableRow>
                    <TableCell colSpan={2} align="center">Cargando...</TableCell>
                  </TableRow>
                ) : (
                  rows.map((row) => (
                    <TableRow key={row.id}>
                      <TableCell align="center">{UtilsTable().validateRowsTable(UtilsDate().formatDDMMMYYYY(new Date(row.datecreated)))}</TableCell>
                      <TableCell align="center">{UtilsTable().validateRowsTable(row.oximetria)}</TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </Paper>
        </Grid>

        {/* Columna para ChartTemp */}
        <Grid item xs={12} lg={6}>
          <Paper className={paperStyle}>
            <ChartTemp data={lIcms} />
          </Paper>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default CardTemp;
